function parsleyValidators() {
    const EmailRegex = /^[A-Za-z0-9._%+-]+@(?:gmail\.com|googlemail\.com|yahoo\.com|ymail\.com|rocketmail\.com|outlook\.com|hotmail\.com|live\.com|msn\.com|aol\.com|icloud\.com|me\.com|mac\.com|mail\.com|fastmail\.com|hey\.com|zoho\.com|protonmail\.com|att\.net|currently\.com|sbcglobal\.net|bellsouth\.net|pacbell\.net|flash\.net|ameritech\.net|prodigy\.net|snet\.net|swbell\.net|nvbell\.net|verizon\.net|comcast\.net|cox\.net|charter\.net|spectrum\.net|rr\.com|twc\.com|brighthouse\.com|optimum\.net|optonline\.net|suddenlink\.net|frontier\.com|frontiernet\.net|centurylink\.net|centurytel\.net|q\.com|embarqmail\.com|cableone\.net|windstream\.net|earthlink\.net|mindspring\.com|peoplepc\.com|juno\.com|netzero\.com)$/i;

    const warningLabel = document.getElementById('companyEmailWarning');
    window.parsley.addValidator('personals', {
        validateString: function (value) {
            const normalizedValue = (value ?? '').trim();

            // Allow any address using a "+test" tag (e.g., joshua+test@gmail.com)
            const bypassPersonalEmailCheck = /\+test(?=@)/i.test(normalizedValue);
            const returnValue = bypassPersonalEmailCheck ? true : !EmailRegex.test(normalizedValue);

            if (returnValue && warningLabel != null) {
                warningLabel.classList.add('d-none');
            }
            else if (warningLabel != null) {
                warningLabel.classList.remove('d-none');
            }
            return returnValue;
        },
        messages: {
            en: 'Company emails only please'
        }
    })
}

parsleyValidators();